import React from 'react';
import './editor.scss'


export const HorizontalBorder  = React.forwardRef((props, ref:any) => {
    return <div ref={ref} className='ruler-markings' style={{ width: '100%', height: '1px', borderTop: '1px solid' }
    }></div >
})